function getPlansToApply(gifts) {
    if (!gifts || !Array.isArray(gifts)) {
      return [];
    }

    const result = gifts
      .filter(gift => ['Minimum quantity of items', 'Minimum purchase amount'].includes(gift.rule_will_applied_based_on_customer_spend_like))
      .reduce((acc, gift) => {
        const limit = parseInt(gift.cart_count) || 0;
        const group = acc.find(g => g.rule === gift.rule_will_applied_based_on_customer_spend_like);
        if (group) {
          group.gifts.push({ plan: gift, limit });
        } else {
          acc.push({ rule: gift.rule_will_applied_based_on_customer_spend_like, gifts: [{ plan: gift, limit }] });
        }
        return acc;
      }, [])
      .map(group => group.gifts.sort((a, b) => b.limit - a.limit)[0].plan);

    return result;
}

function cartHasAllGifts(gifts, cart) {
  return gifts.every(gift => {
    // Check if gift products come from collections
    if (gift.customer_will_get_the_gift_products_from === "Collections") {
      return gift.gift_collections.every(collection => {
        const collectionId = parseInt(collection.replace('gid://shopify/Collection/', ''));
        const matchingCollection = window.collectionsForGiftProducts.find(
          collection => collection.collectionId === collectionId
        );

        if (!matchingCollection) return false;

        // Check if any product from the collection matches cart items
        return matchingCollection.products.some(giftProduct => {
          const giftProductId = giftProduct;
          return cart.items.some(item =>
            item.product_id === giftProductId &&
            item.properties &&
            item.final_line_price === 0 &&
            item.properties._gift_product
          );
        });
      });
    } else {
      // Check direct gift products
      return gift.gift_products.some(giftProductId =>
        cart.items.some(item =>
          `gid://shopify/Product/${item.product_id}` === giftProductId &&
          item.properties &&
          item.final_line_price === 0 &&
          item.properties._gift_product
        )
      );
    }
  });
}
function getPlanItemsQuantity(plan, cart) {
  if (!plan || !cart || !cart.items || !Array.isArray(cart.items)) {
    return 0;
  }
  let planProductIds = [];
  if (plan.customer_will_get_the_gift_products_from === "Collections") {
    planProductIds = plan.gift_collections
      .map(collection => {
        const collectionId = parseInt(collection.replace('gid://shopify/Collection/', ''));
        const matchingCollection = window.collectionsForGiftProducts.find(
          collection => collection.collectionId === collectionId
        );
        return matchingCollection ? matchingCollection.products : [];
      })
      .flat();
  } else {
    planProductIds = plan.gift_products || [];
  }
  return cart.items.reduce((total, item) => {
    const itemProductId = `gid://shopify/Product/${item.product_id}`;
    if (planProductIds.includes(itemProductId)) {
      return total + 1;
    }
    return total;
  }, 0);
}
window.updateHeaders = function(){
  const giftData = sortGiftObjects(window.giftsObject);
  const cartData = window.cartObject;
    const result = getActiveAndNextPlans(giftData, cartData);
  const activePlans = result.activePlans || [];
  const plansToApply = getPlansToApply(activePlans);
  const alreadyAdded = cartHasAllGifts(plansToApply , cartData)
  console.log('alreadyAdded' ,alreadyAdded)
  if(activePlans.length > 0 && !alreadyAdded){
  document.querySelectorAll('#claim_gift_selector')?.forEach(selector => selector.classList.remove('hidden'))
    document.querySelectorAll('activeplan-claimtitles')?.forEach(header => {
    const textContent = plansToApply
    ?.filter(p => getPlanItemsQuantity(p, cartData) === 0)
    .map(p => p.customer_will_receive !== "Automatically all gifts" ? p.title : "")
    .join(" OR ");
    let text = "Claim your" + textContent;
    if(textContent !== ""){
    header.innerHTML = text
    } else{
      header?.closest('.cart-item')?.classList.add('hidden')
    }
   })
  } else{
     document.querySelectorAll('#claim_gift_selector')?.forEach(selector => selector.classList.add('hidden'))
  }
  document.querySelectorAll('gift-header')?.forEach(header => {header.innerHTML = header.getAttribute('slider-btn') ? window.createHeaders(true) : window.createHeaders()  })
  document.querySelectorAll('gift-popupheader')?.forEach(header => header.innerHTML = window.createPopupHeader())
}
window.createHeaders = function(slider) {
  const giftData = sortGiftObjects(window.giftsObject);
  const cartData = window.cartObject;
  const result = getActiveAndNextPlans(giftData, cartData);
  const activePlans = result.activePlans || [];
  const nextPlans = result.nextPlans || [];
  const remainingAmounts = result.remainingAmounts || [];

  let headerText = '';
  
  if (activePlans.length > 0) {
    headerText = 'You have received ';
    activePlans.forEach((plan, index) => {
      headerText += `<strong>${plan.title}</strong>`;
      if (index < activePlans.length - 1) {
        headerText += ', ';
      }
    });
  }
  if (nextPlans.length > 0 && remainingAmounts.length > 0) {
    const nextPlan = nextPlans[0];
    const remainingAmount = remainingAmounts.find(amount => amount.planId === nextPlan.id);
    const nextPlantitle = nextPlan.offer_label
    if (remainingAmount) {
      if (headerText) {
        headerText += '. ';
      }
      if (nextPlantitle) {
        headerText += nextPlantitle.replace(/\[/g, '<strong>').replace(/\]/g, '</strong>');
      } 
    }

}
  
  const headerHTML = `
    <div>
      <div class="frees_gift_objects_list_wrapper main-cart-gift-header ${slider ? 'slider-gift-header' : ""}">
        <span class="gift_icon_popup">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
            <path d="M21.625 6.87506H17.7881C17.8308 6.83897 17.8745 6.80397 17.9161 6.76569C18.2483 6.47057 18.516 6.11008 18.7025 5.70678C18.889 5.30347 18.9903 4.86602 19 4.42178C19.0144 3.9358 18.9293 3.45201 18.7499 3.00011C18.5705 2.54821 18.3007 2.13774 17.9569 1.7939C17.6132 1.45006 17.2028 1.1801 16.751 1.0006C16.2991 0.821096 15.8154 0.735839 15.3294 0.750062C14.885 0.759635 14.4473 0.860843 14.0438 1.04735C13.6403 1.23386 13.2796 1.50165 12.9844 1.83397C12.5758 2.30745 12.2437 2.8418 12 3.41772C11.7563 2.8418 11.4242 2.30745 11.0156 1.83397C10.7204 1.50165 10.3597 1.23386 9.95621 1.04735C9.55271 0.860843 9.11505 0.759635 8.67062 0.750062C8.18464 0.735839 7.70087 0.821096 7.24903 1.0006C6.79718 1.1801 6.38679 1.45006 6.04305 1.7939C5.69931 2.13774 5.42948 2.54821 5.25011 3.00011C5.07074 3.45201 4.98563 3.9358 5 4.42178C5.00972 4.86602 5.111 5.30347 5.29751 5.70678C5.48401 6.11008 5.75172 6.47057 6.08391 6.76569C6.12547 6.80178 6.16922 6.83678 6.21187 6.87506H2.375C1.91087 6.87506 1.46575 7.05944 1.13756 7.38763C0.809374 7.71581 0.625 8.16093 0.625 8.62506V12.1251C0.625 12.5892 0.809374 13.0343 1.13756 13.3625C1.46575 13.6907 1.91087 13.8751 2.375 13.8751V20.8751C2.375 21.3392 2.55937 21.7843 2.88756 22.1125C3.21575 22.4407 3.66087 22.6251 4.125 22.6251H19.875C20.3391 22.6251 20.7842 22.4407 21.1124 22.1125C21.4406 21.7843 21.625 21.3392 21.625 20.8751V13.8751C22.0891 13.8751 22.5342 13.6907 22.8624 13.3625C23.1906 13.0343 23.375 12.5892 23.375 12.1251V8.62506C23.375 8.16093 23.1906 7.71581 22.8624 7.38763C22.5342 7.05944 22.0891 6.87506 21.625 6.87506ZM14.2969 2.99334C14.4354 2.84035 14.6041 2.71765 14.7923 2.63295C14.9805 2.54825 15.1842 2.50338 15.3906 2.50116H15.4442C15.6861 2.50267 15.9253 2.55245 16.1477 2.64758C16.3701 2.74271 16.5713 2.88127 16.7395 3.05516C16.9077 3.22904 17.0395 3.43474 17.1271 3.66021C17.2148 3.88567 17.2566 4.12637 17.25 4.36819C17.2478 4.57458 17.2029 4.77828 17.1182 4.9665C17.0335 5.15472 16.9108 5.32339 16.7578 5.46194C15.7198 6.38069 13.9972 6.70444 12.9297 6.81819C13.0609 5.65991 13.4219 3.97662 14.2969 2.99334ZM7.28703 3.03272C7.62603 2.69375 8.08514 2.50233 8.56453 2.50006H8.61812C8.82451 2.50229 9.02821 2.54716 9.21643 2.63186C9.40465 2.71656 9.57333 2.83926 9.71187 2.99225C10.6295 4.02912 10.9533 5.7485 11.067 6.81162C10.0039 6.70225 8.28453 6.37412 7.24766 5.45647C7.09466 5.31793 6.97196 5.14925 6.88727 4.96103C6.80257 4.77281 6.7577 4.56911 6.75547 4.36272C6.74869 4.11688 6.79192 3.87223 6.88254 3.6436C6.97316 3.41498 7.10929 3.20715 7.28266 3.03272H7.28703ZM2.375 8.62506H11.125V12.1251H2.375V8.62506ZM4.125 13.8751H11.125V20.8751H4.125V13.8751ZM19.875 20.8751H12.875V13.8751H19.875V20.8751ZM21.625 12.1251H12.875V8.62506H21.625V12.1251Z" fill="#F759AB"/></path>
          </svg>
        </span>
        <div class="frees_gift_objects_list">
          <div class="currect_offer_and_next offer">
            <p>${headerText}</p>
          </div>
        </div>
        <button class="add_more_gift-products">${ slider ? `See More Products <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
<path d="M1.53055 0.969444L9.03055 8.46945C9.10029 8.5391 9.15561 8.62182 9.19335 8.71287C9.23109 8.80392 9.25052 8.90151 9.25052 9.00007C9.25052 9.09863 9.23109 9.19623 9.19335 9.28728C9.15561 9.37832 9.10029 9.46104 9.03055 9.5307L1.53055 17.0307C1.38982 17.1714 1.19895 17.2505 0.999929 17.2505C0.800906 17.2505 0.610034 17.1714 0.469303 17.0307C0.328573 16.89 0.249512 16.6991 0.249512 16.5001C0.249512 16.301 0.328573 16.1102 0.469303 15.9694L7.43962 9.00007L0.469303 2.0307C0.399621 1.96101 0.344345 1.87829 0.306633 1.78724C0.268921 1.6962 0.249512 1.59862 0.249512 1.50007C0.249512 1.40152 0.268921 1.30394 0.306633 1.2129C0.344345 1.12185 0.399621 1.03913 0.469303 0.969444C0.538986 0.899763 0.621712 0.844488 0.712756 0.806776C0.803801 0.769064 0.901383 0.749653 0.999929 0.749653C1.09847 0.749653 1.19606 0.769064 1.2871 0.806776C1.37815 0.844488 1.46087 0.899763 1.53055 0.969444Z" fill="white"/>
</svg>`  : `+ Add More Products`}</button>
      </div>
    </div>`;
  if(headerText !== ""){
      return headerHTML;
  } else{
      return "";
  }
};
window.createPopupHeader = function() {
    const giftData = sortGiftObjects(window.giftsObject);
  const cartData = window.cartObject;
  const result = getActiveAndNextPlans(giftData, cartData);
  const activePlans = result.activePlans || [];
  const nextPlans = result.nextPlans || [];
  const remainingAmounts = result.remainingAmounts || [];

  const currentPlan = activePlans?.[0] || null;
  const nextPlan = nextPlans?.[0] || null;
  const offersWithCartItems = giftData.filter(offer => {
  if (offer.rule_applied_based_on === "Collections") {
    return offer.collections.some(collection => {
      const collectionId = parseInt(collection.replace('gid://shopify/Collection/' , ''))
      const matchingCollection = window.collectionsForGiftProducts.find(collection => collection.collectionId === collectionId);
      return matchingCollection && matchingCollection.products.some(product => {
       const productId = parseInt(product.replace('gid://shopify/Product/' , ''))
        return cartData.items.some(item => item.product_id === productId);
      });
    });
  } else {
    return offer.products.some(productId => {
      return cartData.items.some(item => `gid://shopify/Product/${item.product_id}` === productId);
    });
  }
});

  let headerText = '';
  // if (currentPlan) {
  //   headerText += `You have received <strong>${currentPlan.title}</strong>.`;
  // }

  if (activePlans.length > 0) {
    headerText = 'You have received ';
    activePlans.forEach((plan, index) => {
      headerText += `<strong>${plan.title}</strong>`;
      if (index < activePlans.length - 1) {
        headerText += ', ';
      }
    });
    headerText += '.  ';
  }
  if (nextPlan) {
     const nextPlantitle = nextPlan.offer_label
    const amountDifference = nextPlan.cart_count - (currentPlan?.cart_count || 0);
   if (nextPlantitle) {
        headerText += nextPlantitle.replace(/\[/g, '<strong>').replace(/\]/g, '</strong>');
      }
  }
  const fullDetailsList = offersWithCartItems.map((offer, index) => {
    const isCurrent = activePlans && activePlans.includes(offer);
     const Plantitle = offer.offer_label
    return `
      <p class="${isCurrent ? 'active' : ''}">
        ${index + 1}. ${Plantitle ? Plantitle.replace(/\[/g, '<strong>').replace(/\]/g, '</strong>') : ""}
        ${isCurrent ? '- <span>Current</span>' : ''}
      </p>
    `;
  }).join('');

  return `
    <div class="frees_gift_objects_list_wrapper" id="bundle-gift-container-popup-header">
      <span class="gift_icon_popup">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
          <path d="M21.625 6.87506H17.7881C17.8308 6.83897 17.8745 6.80397 17.9161 6.76569C18.2483 6.47057 18.516 6.11008 18.7025 5.70678C18.889 5.30347 18.9903 4.86602 19 4.42178C19.0144 3.9358 18.9293 3.45201 18.7499 3.00011C18.5705 2.54821 18.3007 2.13774 17.9569 1.7939C17.6132 1.45006 17.2028 1.1801 16.751 1.0006C16.2991 0.821096 15.8154 0.735839 15.3294 0.750062C14.885 0.759635 14.4473 0.860843 14.0438 1.04735C13.6403 1.23386 13.2796 1.50165 12.9844 1.83397C12.5758 2.30745 12.2437 2.8418 12 3.41772C11.7563 2.8418 11.4242 2.30745 11.0156 1.83397C10.7204 1.50165 10.3597 1.23386 9.95621 1.04735C9.55271 0.860843 9.11505 0.759635 8.67062 0.750062C8.18464 0.735839 7.70087 0.821096 7.24903 1.0006C6.79718 1.1801 6.38679 1.45006 6.04305 1.7939C5.69931 2.13774 5.42948 2.54821 5.25011 3.00011C5.07074 3.45201 4.98563 3.9358 5 4.42178C5.00972 4.86602 5.111 5.30347 5.29751 5.70678C5.48401 6.11008 5.75172 6.47057 6.08391 6.76569C6.12547 6.80178 6.16922 6.83678 6.21187 6.87506H2.375C1.91087 6.87506 1.46575 7.05944 1.13756 7.38763C0.809374 7.71581 0.625 8.16093 0.625 8.62506V12.1251C0.625 12.5892 0.809374 13.0343 1.13756 13.3625C1.46575 13.6907 1.91087 13.8751 2.375 13.8751V20.8751C2.375 21.3392 2.55937 21.7843 2.88756 22.1125C3.21575 22.4407 3.66087 22.6251 4.125 22.6251H19.875C20.3391 22.6251 20.7842 22.4407 21.1124 22.1125C21.4406 21.7843 21.625 21.3392 21.625 20.8751V13.8751C22.0891 13.8751 22.5342 13.6907 22.8624 13.3625C23.1906 13.0343 23.375 12.5892 23.375 12.1251V8.62506C23.375 8.16093 23.1906 7.71581 22.8624 7.38763C22.5342 7.05944 22.0891 6.87506 21.625 6.87506ZM14.2969 2.99334C14.4354 2.84035 14.6041 2.71765 14.7923 2.63295C14.9805 2.54825 15.1842 2.50338 15.3906 2.50116H15.4442C15.6861 2.50267 15.9253 2.55245 16.1477 2.64758C16.3701 2.74271 16.5713 2.88127 16.7395 3.05516C16.9077 3.22904 17.0395 3.43474 17.1271 3.66021C17.2148 3.88567 17.2566 4.12637 17.25 4.36819C17.2478 4.57458 17.2029 4.77828 17.1182 4.9665C17.0335 5.15472 16.9108 5.32339 16.7578 5.46194C15.7198 6.38069 13.9972 6.70444 12.9297 6.81819C13.0609 5.65991 13.4219 3.97662 14.2969 2.99334ZM7.28703 3.03272C7.62603 2.69375 8.08514 2.50233 8.56453 2.50006H8.61812C8.82451 2.50229 9.02821 2.54716 9.21643 2.63186C9.40465 2.71656 9.57333 2.83926 9.71187 2.99225C10.6295 4.02912 10.9533 5.7485 11.067 6.81162C10.0039 6.70225 8.28453 6.37412 7.24766 5.45647C7.09466 5.31793 6.97196 5.14925 6.88727 4.96103C6.80257 4.77281 6.7577 4.56911 6.75547 4.36272C6.74869 4.11688 6.79192 3.87223 6.88254 3.6436C6.97316 3.41498 7.10929 3.20715 7.28266 3.03272H7.28703ZM2.375 8.62506H11.125V12.1251H2.375V8.62506ZM4.125 13.8751H11.125V20.8751H4.125V13.8751ZM19.875 20.8751H12.875V13.8751H19.875V20.8751ZM21.625 12.1251H12.875V8.62506H21.625V12.1251Z" fill="#F759AB"/>
        </svg>
      </span>
      <div class="frees_gift_objects_list">
        <div class="currect_offer_and_next offer">
          <p>${headerText}</p>
        </div>
        <div class="full_details_of_offers hidden">
          ${fullDetailsList}
        </div>
        <button
          class="full_list_of_all_offers toggle-offers-list"
          close-title="Hide Details"
          open-title="More Details"
        >
          <span>More Details</span>
          <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5.5 5.5L10 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  `;
 }
window.createPopupPorducts = function() {
  const giftData = sortGiftObjects(window.giftsObject);
  const cartData = window.cartObject;
  const matchingPlans = getMatchingPlans(giftData, cartData);
  const productIds = new Set();
  const collectionIds = new Set();
  
 // console.log('matchingPlans' , matchingPlans)
    matchingPlans?.forEach(plan => {
      if (plan.rule_applied_based_on === "Collections") {
        plan.collections?.forEach(c => {
          const collectionId = parseInt(c.replace('gid://shopify/Collection/', ""));
          collectionIds.add(collectionId)
        });
      } else {
        const planProducts = plan.products;
        planProducts?.forEach(p => {
          const productId = parseInt(p.replace('gid://shopify/Product/', ""));
          productIds.add(productId); // Add individual product ID to the Set
        });
      }
    });


  // console.log('productIds' , productIds)
  const url = `/collections/all?view=gift-products&products=${Array.from(productIds)}${collectionIds  ? "&collections=" + Array.from(collectionIds) : ""}`;
  
  getHtmlofgifts(url).then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const giftHtml = doc.querySelector('gift-products');
    const popupGiftGrid = document.querySelector('popup-gitproducts');
    
    if (giftHtml && popupGiftGrid) {
      popupGiftGrid.innerHTML = giftHtml.innerHTML;
    }
  }).catch(error => {
    console.error('Error fetching HTML:', error);
  });
}
window.createClaimPopup = function() {
  const giftData = sortGiftObjects(window.giftsObject);
  const cartData = window.cartObject;
  const result = getActiveAndNextPlans(giftData, cartData);
  const activePlans = result.activePlans || [];
  const nextPlans = result.nextPlans || [];
  const remainingAmounts = result.remainingAmounts || [];
  const giftPopup = document.querySelector('claim-offers');
   giftPopup.innerHTML = ""
  const heighestPlans = findPlanWithHighestLimit(activePlans)

    if (giftPopup) { 
       giftPopup.innerHTML = ""
      activePlans?.forEach(plan => {
       createGiftsPopup(plan)       
      });
       giftPopup.innerHTML +=  `
    <div class="gifts_claim_bottom">
    <button class="continue_without_gifts_btn">Proceed without Free Gift</button>
    </div>
    `
    }
  // console.log('activePlans' , activePlans)
  heighestPlans?.forEach(plan => {
    if(plan && plan.customer_will_receive === "Automatically all gifts"){
      // console.log('heighestPlan' , plan)
      const allAutoProducts =  Array.from(getIdsForAutoAdd(plan))
      const cartHasGifts = getPlanItemsQuantity(plan, cartData)
      // console.log('cartHasGifts' , cartHasGifts)
      const productVariantMap = window.variantsForGiftProducts
      autoAddGiftProducts(allAutoProducts, cartHasGifts , productVariantMap);
    }
  })


}
function autoAddGiftProducts(allAutoProducts, cartHasGifts, productVariantMap) {
  if (!allAutoProducts || !Array.isArray(allAutoProducts) || !productVariantMap) return;
  if (cartHasGifts >= allAutoProducts.length) return;

  const remainingToAdd = allAutoProducts.length - cartHasGifts;
  const productsToAdd = allAutoProducts.slice(cartHasGifts, allAutoProducts.length);

  const items = productsToAdd.reduce((acc, productGid) => {
    const numericProductId = parseInt(productGid.replace('gid://shopify/Product/', ''));
    
    const productData = productVariantMap.find(item => item.id === numericProductId);
    console.log('productData' , productData)
    if (productData && productData.variant_id) {
      acc.push({
        itemId: productData.variant_id,
        quantity: 1,
        property: true
      });
    }
    
    return acc;
  }, []);

  if (items.length > 0) {
    addItemsToCart(items);
  }
}
function addItemsToCart(items) {
  if (!items || !Array.isArray(items) || items.length === 0) {
    console.error('No items provided to add to cart');
    return;
  }
  const url = window.Shopify.routes.root + 'cart/add.js';
  const formData = {
    items: items.map(item => ({
      id: parseInt(item.itemId),
      quantity: parseInt(item.quantity) || 1,
      properties: item.property ? { 
        '_gift_product': true,
        '_gift_added': new Date().toISOString()
      } : {}
    }))
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then((response) => {
    document.querySelectorAll('.gift_popup_loader')?.forEach(loader => 
      loader.classList.add('hidden')
    );
    console.log('Items added to cart:', response);
    const currentLocation = window.location.href;
    if (currentLocation.includes('/cart')) {
      window.location.reload();
    } else {
      window.location.href = window.Shopify.routes.root + "cart";
    }
  })
  .catch(error => {
    console.error('Error adding items to cart:', error);
    document.querySelectorAll('.gift_popup_loader')?.forEach(loader => 
      loader.classList.add('hidden')
    );
    if (window.showErrorMessage) {
      window.showErrorMessage('Failed to add items to cart. Please try again.');
    }
  });
}

function getIdsForAutoAdd(plan) {
  if (!plan) return [];
  let productIds = [];
  const giftLimit = parseInt(plan.gifts_limit) || 0;
  if (plan.customer_will_get_the_gift_products_from === "Collections") {
    productIds = plan.gift_collections
      .reduce((ids, collectionGid) => {
        const collectionId = parseInt(collectionGid.replace('gid://shopify/Collection/', ''));
        const matchingCollection = window.collectionsForGiftProducts.find(
          collection => collection.collectionId === collectionId
        );
        if (matchingCollection && matchingCollection.products) {
          return [...ids, ...matchingCollection.products];
        }
        return ids;
      }, []);
  } 
  else if (plan.gift_products && Array.isArray(plan.gift_products)) {
    productIds = [...plan.gift_products];
  }
  productIds = [...new Set(productIds)];
  return productIds.slice(0, giftLimit);
}
function findPlanWithHighestLimit(activePlans) {
  if (!activePlans || !Array.isArray(activePlans)) {
    return null;
  }
  const sortedPlans = [...activePlans].sort((a, b) => {
    const limitA = parseInt(a.gifts_limit) || 0;
    const limitB = parseInt(b.gifts_limit) || 0;
    if (a.rule_will_applied_based_on_customer_spend_like === b.rule_will_applied_based_on_customer_spend_like) {
      return limitB - limitA;
    }
    return limitA - limitB;
  });
  return sortedPlans || null;
}

function createGiftsPopup(plan) {
  const giftPopup = document.querySelector('claim-offers');
  const planProducts = plan.gift_products || []; // Use an empty array if `gift_products` is missing
  let Gridproducts = '';
  const cartData = window.cartObject;
    const productIds = new Set();
     const collectionIds = new Set();
      if (plan.customer_will_get_the_gift_products_from === "Collections") {
        // console.log('plan ruel' , plan)
        plan.gift_collections?.forEach(c => {
          const collectionId = parseInt(c.replace('gid://shopify/Collection/', ""));
          // const matchingCollection = window.collectionsForGiftProducts.find(collection => collection.collectionId === collectionId);
          collectionIds.add(collectionId)
        });
      } else {
        const planProducts = plan.gift_products;
        planProducts?.forEach(p => {
          const productId = parseInt(p.replace('gid://shopify/Product/', ""));
          productIds.add(productId); // Add individual product ID to the Set
        });
      }

  const url = `/collections/all?view=gift-products&products=${Array.from(productIds)}${collectionIds ? "&collections=" + Array.from(collectionIds) : ""}&is-gift=true&gift-limit=${plan.gifts_limit}`;
 
  getHtmlofgifts(url).then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const giftHtml = doc.querySelector('gift-products');
    const addedItems = getPlanItemsQuantity(plan, cartData) 
    Gridproducts = giftHtml ? giftHtml.innerHTML : ''; 
 giftPopup.innerHTML +=  `
    <div class="wraper_gift-offer_gifts">
       <h4 class="gift-popup_title">${plan.title ? `${plan.title}.` : 'No gift available.'}</h4>
      <h3 class="reminder_for_adding_gifts" data-added="${addedItems}" data-title="You can add ${plan.gifts_limit} gift product${plan.gifts_limit > 1 ? "s" : ""}" data-add-title="You have added [added]/${plan.gifts_limit} gift product${plan.gifts_limit > 1 ? "s" : ""}" ${plan.gifts_limit === 1 ? 'style="display: none;"' : ''}>
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
          <path d="M21.625 6.87506H17.7881C17.8308 6.83897 17.8745 6.80397 17.9161 6.76569C18.2483 6.47057 18.516 6.11008 18.7025 5.70678C18.889 5.30347 18.9903 4.86602 19 4.42178C19.0144 3.9358 18.9293 3.45201 18.7499 3.00011C18.5705 2.54821 18.3007 2.13774 17.9569 1.7939C17.6132 1.45006 17.2028 1.1801 16.751 1.0006C16.2991 0.821096 15.8154 0.735839 15.3294 0.750062C14.885 0.759635 14.4473 0.860843 14.0438 1.04735C13.6403 1.23386 13.2796 1.50165 12.9844 1.83397C12.5758 2.30745 12.2437 2.8418 12 3.41772C11.7563 2.8418 11.4242 2.30745 11.0156 1.83397C10.7204 1.50165 10.3597 1.23386 9.95621 1.04735C9.55271 0.860843 9.11505 0.759635 8.67062 0.750062C8.18464 0.735839 7.70087 0.821096 7.24903 1.0006C6.79718 1.1801 6.38679 1.45006 6.04305 1.7939C5.69931 2.13774 5.42948 2.54821 5.25011 3.00011C5.07074 3.45201 4.98563 3.9358 5 4.42178C5.00972 4.86602 5.111 5.30347 5.29751 5.70678C5.48401 6.11008 5.75172 6.47057 6.08391 6.76569C6.12547 6.80178 6.16922 6.83678 6.21187 6.87506H2.375C1.91087 6.87506 1.46575 7.05944 1.13756 7.38763C0.809374 7.71581 0.625 8.16093 0.625 8.62506V12.1251C0.625 12.5892 0.809374 13.0343 1.13756 13.3625C1.46575 13.6907 1.91087 13.8751 2.375 13.8751V20.8751C2.375 21.3392 2.55937 21.7843 2.88756 22.1125C3.21575 22.4407 3.66087 22.6251 4.125 22.6251H19.875C20.3391 22.6251 20.7842 22.4407 21.1124 22.1125C21.4406 21.7843 21.625 21.3392 21.625 20.8751V13.8751C22.0891 13.8751 22.5342 13.6907 22.8624 13.3625C23.1906 13.0343 23.375 12.5892 23.375 12.1251V8.62506C23.375 8.16093 23.1906 7.71581 22.8624 7.38763C22.5342 7.05944 22.0891 6.87506 21.625 6.87506ZM14.2969 2.99334C14.4354 2.84035 14.6041 2.71765 14.7923 2.63295C14.9805 2.54825 15.1842 2.50338 15.3906 2.50116H15.4442C15.6861 2.50267 15.9253 2.55245 16.1477 2.64758C16.3701 2.74271 16.5713 2.88127 16.7395 3.05516C16.9077 3.22904 17.0395 3.43474 17.1271 3.66021C17.2148 3.88567 17.2566 4.12637 17.25 4.36819C17.2478 4.57458 17.2029 4.77828 17.1182 4.9665C17.0335 5.15472 16.9108 5.32339 16.7578 5.46194C15.7198 6.38069 13.9972 6.70444 12.9297 6.81819C13.0609 5.65991 13.4219 3.97662 14.2969 2.99334ZM7.28703 3.03272C7.62603 2.69375 8.08514 2.50233 8.56453 2.50006H8.61812C8.82451 2.50229 9.02821 2.54716 9.21643 2.63186C9.40465 2.71656 9.57333 2.83926 9.71187 2.99225C10.6295 4.02912 10.9533 5.7485 11.067 6.81162C10.0039 6.70225 8.28453 6.37412 7.24766 5.45647C7.09466 5.31793 6.97196 5.14925 6.88727 4.96103C6.80257 4.77281 6.7577 4.56911 6.75547 4.36272C6.74869 4.11688 6.79192 3.87223 6.88254 3.6436C6.97316 3.41498 7.10929 3.20715 7.28266 3.03272H7.28703ZM2.375 8.62506H11.125V12.1251H2.375V8.62506ZM4.125 13.8751H11.125V20.8751H4.125V13.8751ZM19.875 20.8751H12.875V13.8751H19.875V20.8751ZM21.625 12.1251H12.875V8.62506H21.625V12.1251Z" fill="#F759AB"/>
        </svg> <span>
        ${addedItems > 0 ? `You have added ${addedItems}/${plan.gifts_limit} gift product${plan.gifts_limit > 1 ? "s" : ""}` : `You can add ${plan.gifts_limit} gift product${plan.gifts_limit > 1 ? "s" : ""}`}</span></h3>
      <div class="list_offer_products_wrapper">
        <div class="grid_offer_products gifts-slider-grid">
          ${Gridproducts}
        </div>
      </div>
    </div>
  `;
     }).catch(error => {
    console.error('Error fetching HTML:', error);
  });
}
async function getHtmlofgifts(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
    const html = await response.text();
    return html;
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
}
function getMatchingPlans(gifts, cart) {
  return gifts.filter(gift => {
   if (gift.rule_applied_based_on === "Collections") {
    return gift.collections.some(collection => {
      const collectionId = parseInt(collection.replace('gid://shopify/Collection/' , ''))
      const matchingCollection = window.collectionsForGiftProducts.find(collection => collection.collectionId === collectionId);
      return matchingCollection && matchingCollection.products.some(product => {
        const productId = parseInt(product.replace('gid://shopify/Product/' , ''))
        const cartMatching = cart.items.some(item => item.product_id === productId);
         // console.log('cartMatching' , cartMatching)
        return cartMatching
      });
    });
  } else {
    return gift.products.some(productId => {
      return cart.items.some(item => `gid://shopify/Product/${item.product_id}` === productId);
    });
  }
  });
}



function formatToIDR(number) {
  if (number === null || number === undefined) return 'Rp 0';
  
  try {
    const numericValue = typeof number === 'string' ? parseFloat(number) : number;
    return `Rp ${numericValue.toLocaleString('id-ID')}`;
  } catch (error) {
    return 'Rp 0';
  }
}

function getActiveAndNextPlans(sortedGiftData, cartData) {
 const activePlans = [];
 const nextPlans = [];
 const processedProductSets = new Set();

 sortedGiftData.forEach((giftOffer, index) => {
   let offer_products = giftOffer.products
   let matchingTotal = calculateMatchingTotal(offer_products, cartData.items);
   
     if (giftOffer.rule_applied_based_on === "Collections") {
      const matchingProducts = giftOffer.collections.reduce((matchingProducts, collection) => {
        const collectionId = parseInt(collection.replace('gid://shopify/Collection/', ''));
        const matchingCollection = window.collectionsForGiftProducts.find(collection => collection.collectionId === collectionId);
    
        if (matchingCollection) {
          matchingCollection.products.forEach(collectionProductId => {
              matchingProducts.push(collectionProductId);
          });
        }
    
        return matchingProducts;
      }, []);
      
      offer_products =  matchingProducts;
    }
    if(giftOffer.rule_will_applied_based_on_customer_spend_like === "Minimum quantity of items"){      
      matchingTotal = calculateMatchingQty(offer_products, cartData.items);
    
    } 
   const planRule = giftOffer.rule_will_applied_based_on_customer_spend_like
   if (matchingTotal >= giftOffer.cart_count) {
     const overlappingPlan = activePlans.find(plan => 
       hasCommonProducts(plan.products, giftOffer.products) && plan.rule_will_applied_based_on_customer_spend_like === planRule
     );
     if (!overlappingPlan) {
       activePlans.push(giftOffer);
       giftOffer.products.forEach(prod => processedProductSets.add(prod));
     } else {
       if (giftOffer.cart_count > overlappingPlan.cart_count &&  overlappingPlan.rule_will_applied_based_on_customer_spend_like === giftOffer.rule_will_applied_based_on_customer_spend_like ) {
         const index = activePlans.indexOf(overlappingPlan);
         activePlans[index] = giftOffer;
       }
     }
    
   } else {
     const isRelevantNextPlan = giftOffer.products.some(prod => {
       const productInCart = cartData.items.some(item => 
         `gid://shopify/Product/${item.product_id}` === prod
       );
       return productInCart;
     });
       
     if (isRelevantNextPlan) {
       const relatedActivePlan = activePlans.find(plan => 
         hasCommonProducts(plan.products, giftOffer.products)
       );

       if (relatedActivePlan) {
         if (giftOffer.cart_count > relatedActivePlan.cart_count) {
           const existingNextPlan = nextPlans.find(plan => 
             hasCommonProducts(plan.products, giftOffer.products)
           );
      

           if (!existingNextPlan || giftOffer.cart_count < existingNextPlan.cart_count) {
             if (existingNextPlan) {
               nextPlans.splice(nextPlans.indexOf(existingNextPlan), 1);
             }
             nextPlans.push(giftOffer);
           }
         }
       } else {
         const existingNextPlan = nextPlans.find(plan => 
           hasCommonProducts(plan.products, giftOffer.products)
         );
         if (!existingNextPlan || giftOffer.cart_count < existingNextPlan.cart_count) {
           if (existingNextPlan) {
             nextPlans.splice(nextPlans.indexOf(existingNextPlan), 1);
           }
           nextPlans.push(giftOffer);
         }
       }
     }
   }
 });

 return {
   activePlans,
   nextPlans,
   remainingAmounts: nextPlans.map(plan => {
     const matchingTotal = calculateMatchingTotal(plan.products, cartData.items);
     return {
       remainingAmount: plan.cart_count - matchingTotal
     };
   })
 };
}

 function calculateMatchingTotal(offerProducts, cartItems) {
   return cartItems.reduce((total, cartItem) => {
     const productId = cartItem.product_id;
     if (offerProducts.includes(`gid://shopify/Product/${productId}`) || offerProducts.includes(productId)) {
       return total + (cartItem.final_line_price / 100);
     }
     return total;
   }, 0);
 }
 function calculateMatchingQty(offerProducts, cartItems) {
   return cartItems.reduce((total, cartItem) => {
     const productId = cartItem.product_id;
     if (offerProducts.includes(`gid://shopify/Product/${productId}`) || offerProducts.includes(productId)) {
       return total + (cartItem.quantity);
     }
     return total;
   }, 0);
 }

 function hasCommonProducts(products1, products2) {
   return products1.some(product => products2.includes(product));
 }
window.collectAllData = function(){
  const giftData = sortGiftObjects(window.giftsObject)
  const cartData = window.cartObject
  // console.log('giftData' , giftData)
}
function sortGiftObjects(giftObjects) {
  const qtyRuleTrue = giftObjects.filter(obj => obj.rule_will_applied_based_on_customer_spend_like === "Minimum quantity of items");
  const qtyRuleFalse = giftObjects.filter(obj => obj.rule_will_applied_based_on_customer_spend_like === "Minimum purchase amount");
  const sortByCartCount = (a, b) => a.cart_count - b.cart_count;
  const sortedQtyRuleTrue = qtyRuleTrue.sort(sortByCartCount);
  const sortedQtyRuleFalse = qtyRuleFalse.sort(sortByCartCount);
  return [...sortedQtyRuleTrue, ...sortedQtyRuleFalse];
}
window.checkUnUsedGifts = function(){
  async function removeMultipleItemsFromCart(itemIds) {
    if(!itemIds || itemIds.length < 1) return
      try {
        const updates = itemIds.reduce((acc, id) => {
          acc[id] = 0;
          return acc;
        }, {});
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: updates
          })
        });
    
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const updatedCart = await response.json();
        const existingCart = document.querySelector('cart-items');
        const newCart = document.createElement('cart-items');
        newCart.innerHTML = existingCart.innerHTML
        existingCart.replaceWith(newCart);
        // console.log('newCart:', newCart);
        window.cartObject = updatedCart
        return updatedCart;
    
      } catch (error) {
        console.error('Error removing items from cart:', error);
        throw error;
      }
    }
    const cartItems = window.cartObject.items
    const getFreeItems = cartItems.filter(item => 
        item.properties?._gift_product && 
        item.properties._gift_product === true && 
        item.final_line_price > 0
    ).map(item => item.id);
     window.unUsedGifts = getFreeItems
    const itemIdsToRemove = getFreeItems;
    removeMultipleItemsFromCart(itemIdsToRemove)
      .then(updatedCart => {
        // window.cartObject = updatedCart
        // console.log('Cart updated:', updatedCart);
      })
      .catch(error => {
        console.error('Failed to remove items:', error);
      });
}
window.updateGifts = function(){
  window.updateHeaders()
  window.createPopupPorducts()
  window.createClaimPopup()
  window.checkUnUsedGifts()
}
window.updateGifts()
